import { Injectable } from '@angular/core';
import { MtxDatetimepickerIntl } from '@ng-matero/extensions/datetimepicker';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class MtxDatetimepickerIntlExtension extends MtxDatetimepickerIntl {
  constructor(private translateService: TranslateService) {
    super();
    this.setTranslations();

    this.translateService.onLangChange.subscribe(() => {
      this.setTranslations();
      this.changes.next();
    });
  }

  setTranslations() {
    this.cancelLabel = this.translateService.instant('common.cancel');
    this.okLabel = this.translateService.instant('common.apply');
  }
}